'use es6';

import styled from 'styled-components';
import I18n from 'I18n';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
const PixelStepperFormatter = val => val != null ? `${I18n.formatNumber(val, {
  precision: 1
})}px` : val;
const PixelStepperInput = styled(UIStepperInput).attrs(() => ({
  formatter: PixelStepperFormatter
})).withConfig({
  displayName: "TablePopoverPixelStepperInput__PixelStepperInput",
  componentId: "wy3ix0-0"
})(["min-width:", " !important;max-width:", " !important;& input{min-height:32px;}"], ({
  width
}) => width || '100%', ({
  width
}) => width || '100%');
export default PixelStepperInput;